import type { FaireProductEntity } from "../../entity_types/product";

export const p_s557stqyqr: FaireProductEntity = {
  token: "p_s557stqyqr",
  type: "product",
  name: "10 pc Mini Gem crosses for Crystal grids F429",
  brandToken: "b_yrt8x5m6m6",
  brandName: "The 7 Directions",
  imageUrl:
    "https://cdn.faire.com/fastly/e84992e020f40f57daa92aba40f43e31a5419bd956d0a15bebbce97e33fff478.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a15b7bbc592bd8905349601bd0554fc8adc59eac1a43b4f22e285395ee458265.jpeg",
  ],
  priceDollars: 10.39,
  description:
    '10 pc Mini Gem crosses for Crystal grids F429\n\nThey are approx 1" tall\n\nThese are random picks\n\nPlease note that these gem crosses are mix lot with both natural and man made stones\n\n',
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:55.006Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
